import { createRouter, createWebHistory } from 'vue-router'

import { isAdmin } from '@/libs/auth'
import { rocnoRoutes } from '@/router/rocno'

declare module 'vue-router' {
  interface RouteMeta {
    requiresAuth?: boolean
    requiresAdmin?: boolean
  }
}

// There is no /login route: the whole app is covered by the LockOverlay until a person
// signs in (layouts/components/LockOverlay.vue), so every route is simply `requiresAuth`.
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { selector: to.hash }
    if (from.path === to.path) return {}
    return { top: 0, behavior: 'smooth' }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/Home.vue'),
      meta: { requiresAuth: true },
    },

    // Linija
    {
      path: '/linija/nov',
      name: 'linija-nov',
      component: () => import('@/views/entry/Entry.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/linija/pregled',
      name: 'linija-pregled',
      component: () => import('@/views/pregled/Overview.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/linija/evidenca',
      name: 'linija-evidenca',
      component: () => import('@/views/evidenca/Log.vue'),
      meta: { requiresAuth: true },
    },

    // Ročno (/rocno/*)
    ...rocnoRoutes,

    // Skupno
    {
      path: '/sifranti',
      name: 'sifranti',
      component: () => import('@/views/sifranti/Registries.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/sledljivost',
      name: 'sledljivost',
      component: () => import('@/views/sledljivost/Audit.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/navodila',
      name: 'navodila',
      component: () => import('@/views/navodila/Guide.vue'),
      meta: { requiresAuth: true },
    },

    // Old Linija paths (before the app got two modules) and anything unknown go to Domov / the new path.
    { path: '/entry', redirect: '/linija/nov' },
    { path: '/overview', redirect: '/linija/pregled' },
    { path: '/log', redirect: '/linija/evidenca' },
    { path: '/registries', redirect: '/sifranti' },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach((to) => {
  if (to.meta.requiresAdmin && !isAdmin()) return { name: 'home' }
  return true
})

export default router
